// Single "today's maintenance" card. Mirrors PriorityCard from
// designproject/files/screens-feed.jsx (HomeC variant). Safety-critical items
// (газ/электрика/огнетушитель) get the warm amber highlight via tone='safety';
// orphan items reuse the same amber palette to surface them as needing
// attention. Brand/neutral tones reserved for seasonal and ordinary tasks.

import type { JSX } from 'preact';
import { T, Icon, Chip, Avatar } from '../../tokens';
import type { TodayTask, TaskTone } from './types';

interface ToneStyle {
  readonly bg: string;
  readonly fg: string;
  readonly bd: string;
  readonly avatar: 'ai' | 'warn' | 'sys';
}

const TONE: Record<TaskTone, ToneStyle> = {
  safety: { bg: T.safetySoft, fg: T.safety, bd: '#E8D7A8', avatar: 'warn' },
  orphan: { bg: T.safetySoft, fg: T.safety, bd: '#E8D7A8', avatar: 'warn' },
  brand: { bg: T.brandSoft, fg: T.brandDeep, bd: T.brandSoft2, avatar: 'ai' },
  neutral: { bg: T.surface, fg: T.ink, bd: T.border, avatar: 'sys' },
};

interface TodayCardProps {
  readonly task: TodayTask;
  readonly onClick: () => void;
}

export function TodayCard({ task, onClick }: TodayCardProps): JSX.Element {
  const tone = TONE[task.tone];
  return (
    <div
      onClick={onClick}
      style={{
        background: tone.bg,
        border: `1px solid ${tone.bd}`,
        borderRadius: 16,
        padding: 14,
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <Avatar kind={tone.avatar} icon={task.icon} size={36} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              flexWrap: 'wrap',
            }}
          >
            <span
              style={{
                fontSize: 11.5,
                fontWeight: 700,
                color: tone.fg,
                textTransform: 'uppercase',
                letterSpacing: 0.3,
              }}
            >
              {task.when}
            </span>
            {task.tone === 'safety' && <Chip tone="safety">safety</Chip>}
          </div>
          <div
            style={{
              fontSize: 14.5,
              fontWeight: 700,
              color: T.ink,
              marginTop: 4,
              lineHeight: 1.3,
            }}
          >
            {task.title}
          </div>
          <div style={{ fontSize: 12.5, color: T.ink3, marginTop: 3 }}>
            {task.sub}
          </div>
        </div>
        <div style={{ marginTop: 6 }}>
          <Icon name="chevR" size={16} color={T.ink3} />
        </div>
      </div>
    </div>
  );
}
